import { Toaster as Sonner, type ToasterProps } from "sonner";

/** Sonner toasts on the KORI surface: raised panel, hairline, 12px radius, elevation 3. */
function Toaster({ theme, ...props }: ToasterProps & { theme: "light" | "dark" }) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      className="toaster"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "flex w-[var(--width)] max-w-[calc(100vw-2rem)] items-start gap-3 rounded-md border border-border bg-popover p-4 font-sans text-sm text-popover-foreground shadow-(--elevation-3)",
          title: "font-semibold leading-snug text-ink",
          description: "mt-0.5 leading-snug text-muted",
          icon: "mt-0.5 text-success [&_svg]:size-4",
          // An error is never marked with the success color.
          error: "border-danger [&_[data-icon]]:text-danger",
          actionButton:
            "ms-auto inline-flex h-(--control-h-sm) cursor-pointer items-center rounded-control border border-border-strong bg-transparent px-3 text-xs font-semibold text-heading hover:bg-surface-active",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
